import { useEffect } from 'react'
import { ImageName } from 'common/api/v1/types'
import FaviconPng from '../../img/favicon.png'
import { useFetchedImage } from './LogoFetcher'

/** Points the browser tab icon at the uploaded favicon, and follows it when branding changes. */
export const DocumentFavicon = () => {
  const { source, type } = useFetchedImage(ImageName.favicon)

  useEffect(() => {
    if (source === '') return // branding not loaded yet

    let link = document.querySelector<HTMLLinkElement>("link[rel~='icon']")
    if (!link) {
      link = document.createElement('link')
      link.rel = 'icon'
      document.head.appendChild(link)
    }
    link.href = source ?? FaviconPng
    link.type = source === null ? 'image/png' : `image/${type}`
  }, [source, type])

  return null
}
